'use client';
import { useRef } from 'react';
import { useSite } from '../lib/i18n';
import { pickName } from '../lib/i18n-core';
import { Icon } from './Icon';
import { SmartLink } from './SmartLink';

export interface TeacherItem {
  id: number;
  name: string | null;
  imageName: string | null;
  slogan: string | null;
  categoryName: Record<string, string> | null;
}

/**
 * 강사 섹션 — 현행 owl 캐러셀 계승: 카드 여러 장을 가로로, 좌우 버튼으로 넘긴다.
 * 라이브러리 없이 가로 스크롤(스냅) + 스크롤 버튼 — 모바일은 손으로 민다.
 * 카드에 [분류명](현행 GET_CTNAME)·이름·슬로건. 강사 상세는 ③ 단계(/teachers/[id]).
 */
export function TeacherCarousel({ items }: { items: TeacherItem[] }) {
  const { lang } = useSite();
  const ref = useRef<HTMLDivElement>(null);
  if (!items.length) return null;

  const scroll = (dir: 1 | -1) => {
    const el = ref.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
  };

  return (
    <div className="teacher-carousel">
      {items.length > 3 && (
        <button className="bn-arr bn-arr-prev" onClick={() => scroll(-1)} aria-label="prev"><Icon name="chevron-left" /></button>
      )}
      <div className="teacher-track" ref={ref}>
        {items.map((x) => (
          <SmartLink className="course-card teacher-card" key={x.id} href={`/teachers/${x.id}`}>
            <div className="course-thumb">
              {x.imageName
                ? <img src={x.imageName} alt={x.name ?? ''} />
                : <div className="course-no-img"><Icon name="user-round" /></div>}
            </div>
            <div className="course-body">
              {x.categoryName && <p className="course-chips">[ {pickName(x.categoryName, lang)} ]</p>}
              <p className="course-title">{x.name}</p>
              {x.slogan && <p className="course-chips">{x.slogan}</p>}
            </div>
          </SmartLink>
        ))}
      </div>
      {items.length > 3 && (
        <button className="bn-arr bn-arr-next" onClick={() => scroll(1)} aria-label="next"><Icon name="chevron-right" /></button>
      )}
    </div>
  );
}
